// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2T45E","content":"RecentSearches_content__2eWNf"};